import { LoadableResponse, Restaurant } from "api-types";
import { StyledButton } from "igfd-ui";

import React from "react";

import { Stack, Tooltip, Typography } from "@mui/material/";

import {
  ExpandCircleDownOutlined,
  OfflineBoltRounded,
  VerifiedRounded,
} from "@mui/icons-material";

import { RestaurantModal } from "../../RestaurantModal/RestaurantModal";

export const SelectedRestaurant = ({
  isLargeScreen,
  menuUrl,
  selectedRestaurant,
}: {
  isLargeScreen: boolean;
  selectedRestaurant: Restaurant;
  menuUrl: LoadableResponse<string>;
}) => {
  const { data: menuUrlData, isLoading: menuUrlLoading } = menuUrl;

  const [restaurantSelectionModal, setRestaurantSelectionModal] =
    React.useState(false);

  return (
    <Stack
      display={"flex"}
      height={"36px"}
      spacing={1}
      direction={"row"}
      alignItems={"center"}
      sx={(theme) => ({
        borderRadius: "32px",
        border: `1px solid ${theme.palette.grey[400]}`,
        padding: `${theme.spacing(0)} ${theme.spacing(1)}`,
      })}
    >
      <Tooltip title="Switch restaurant">
        <ExpandCircleDownOutlined
          color={"secondary"}
          fontSize={"small"}
          sx={{ cursor: "pointer" }}
          onClick={() => setRestaurantSelectionModal(true)}
        />
      </Tooltip>
      <Tooltip title={selectedRestaurant.name}>
        <Typography
          variant={"caption"}
          overflow={"hidden"}
          noWrap
          sx={(theme) => ({
            fontFamily: theme.typography.h3.fontFamily,
            fontSize: theme.typography.caption.fontSize,
            maxWidth: isLargeScreen ? "100%" : 100,
            cursor: "pointer",
          })}
          onClick={() => setRestaurantSelectionModal(true)}
        >
          {selectedRestaurant.name}
        </Typography>
      </Tooltip>
      <Tooltip
        title={
          selectedRestaurant.appStatus === "listed"
            ? "Live on the app"
            : "Not live on app"
        }
      >
        <OfflineBoltRounded
          fontSize={"small"}
          sx={({ palette }) => ({
            color:
              selectedRestaurant.appStatus === "listed"
                ? palette.primary.main
                : palette.grey.A400,
          })}
        />
      </Tooltip>
      {selectedRestaurant.verified && (
        <Tooltip title={"Verified"}>
          <VerifiedRounded sx={{ color: " #00A3FF", fontSize: "14px" }} />
        </Tooltip>
      )}

      <StyledButton
        onClick={() => window.open(menuUrlData, "_blank")}
        variant={"outlined"}
        color={"secondary"}
        label={"Preview"}
        size={"small"}
        loading={menuUrlLoading}
        sx={(theme) => ({
          color: theme.palette.secondary.main,
          fontSize: theme.typography.caption.fontSize,
          borderColor: theme.palette.secondary.light,
          borderWidth: "2px",
          height: "24px",
          lineHeight: 1,
        })}
      />
      <RestaurantModal
        open={restaurantSelectionModal}
        onClose={() => setRestaurantSelectionModal(false)}
        onNewRestaurantCreated={() => setRestaurantSelectionModal(false)}
      />
    </Stack>
  );
};
